export enum TimelineKeyframeShape {
  None = 'none',
  Rhomb = 'rhomb',
  Circle = 'circle',
  Rect = 'rect',
}
